import request from 'api/requestUtils'
import type { paths } from '@luxuryescapes/contract-cart'

type PatchMultiCartItemRequest = Omit<paths['/api/carts/multi-carts/{multiCartId}/items']['patch']['parameters']['body']['payload'], 'brand'>
type PatchMultiCartItemResponse = paths['/api/carts/multi-carts/{multiCartId}/items']['patch']['responses']['200']['content']['application/json']

export async function patchItemsInMultiCart(multiCartId: string, input: { itemIds: Array<string>, saveForLater: boolean, skipNotification: boolean }): Promise<{ itemIds: Array<string>, saveForLater: boolean, skipNotification: boolean }> {
  if (input.itemIds.length === 0) {
    return Promise.resolve({ itemIds: [], saveForLater: false, skipNotification: input.skipNotification })
  }
  const payload = {
    itemIds: input.itemIds,
    update: { saveForLater: input.saveForLater },
  }

  await request.patch<PatchMultiCartItemResponse, PatchMultiCartItemRequest>(`/api/carts/multi-carts/${multiCartId}/items`, payload, { credentials: 'include' })

  return { itemIds: input.itemIds, saveForLater: input.saveForLater, skipNotification: input.skipNotification }
}
